module.exports = __webpack_public_path__ + "static/media/saved-search.1c9a4839.svg";